import React, { useState } from "react";
import { Input } from "antd";
import { Button, Form } from "antd/lib";
import { IBankDetailFormModel } from "./types/bank-detail.types";

interface IBankDetailViewProps {
    viewModal: IBankDetailFormModel
    onSubmit: (values: IBankDetailFormModel) => Promise<void>;
}

const BankDetailView = (props: IBankDetailViewProps) => {
    const [bankDetailsForm] = Form.useForm();
    const [valid, setIsValid] = useState<boolean>(true);
    const variant = Form.useWatch('variant', bankDetailsForm);


    const onFieldsChange = () => {
        const hasErrors = bankDetailsForm.getFieldsError().some(({errors}) => errors.length);
        const allFilled = Object.values(bankDetailsForm.getFieldsValue()).every(v => v !== undefined && v !== '');
        setIsValid(!hasErrors && allFilled);
    };

    async function handleFormFinish() {
        await bankDetailsForm.validateFields()
            .then((formValues: IBankDetailFormModel) => {
                console.log("Form Values: ", formValues);
                setIsValid(true);
                props.onSubmit(formValues);
            })
            .catch(() => setIsValid(false));
    }

    const handleResetFields = () => {
        bankDetailsForm.resetFields();
    }

    return (
        <section className={'hrms__employee-create__form bank-details'}>
            <div className={'formHeadings'}>
                <h2>Bank Details</h2>
            </div>

            <Form
                layout={'vertical'}
                form={bankDetailsForm}
                className={"hrms__experience-section bank-details"}
                variant={variant || 'filled'}
                onValuesChange={onFieldsChange}
                onFinish={handleFormFinish}
                initialValues={props.viewModal}
            >
                <div className={'bankDetailsBox'}>
                    <Form.Item
                        name={"name"}
                        label={"Bank Name"}
                        className={"formInputFields"}
                        required={true}
                        rules={[
                            () => ({
                                validator(_, value) {
                                    if (!value) {
                                        return Promise.reject();
                                    }
                                    if (!isNaN(value)) {
                                        return Promise.reject("Bank Name should be text.");
                                    }
                                    return Promise.resolve();
                                },
                            }),
                        ]}
                    >
                        <Input placeholder={'Enter bank name'}/>
                    </Form.Item>

                    <Form.Item
                        name={"accountHolderName"}
                        label={"Account Holder Name"}
                        className={"formInputFields"}
                        required={true}
                        rules={[
                            () => ({
                                validator(_, value) {
                                    if (!value) {
                                        return Promise.reject();
                                    }
                                    if (!isNaN(value)) {
                                        return Promise.reject("Account Holder name should be text.");
                                    }
                                    return Promise.resolve();
                                },
                            }),
                        ]}
                    >
                        <Input placeholder={'Enter account holder name'}/>
                    </Form.Item>

                    <Form.Item
                        name={"accountNumber"}
                        label={"Account Number"}
                        className={"formInputFields"}
                        required={true}
                        rules={[
                            () => ({
                                validator(_, value) {
                                    if (!value) {
                                        return Promise.reject();
                                    }
                                    if (!/^\d+$/.test(value)) {
                                        return Promise.reject("Account number should contain only digits.");
                                    }
                                    return Promise.resolve();
                                },
                            }),
                        ]}
                    >
                        <Input placeholder={'Enter account number'}/>
                    </Form.Item>

                    <Form.Item
                        name={"ifscCode"}
                        label={"IFSC Code"}
                        className={"formInputFields"}
                        required={true}
                        rules={[
                            () => ({
                                validator(_, value) {
                                    if (!value) {
                                        return Promise.reject();
                                    }
                                    if (value.length !== 11) {
                                        return Promise.reject("IFSC code length should be 11.");
                                    }
                                    return Promise.resolve();
                                },
                            }),
                        ]}
                    >
                        <Input placeholder={'Enter IFSC code'}/>
                    </Form.Item>

                    <Form.Item
                        name={"branchName"}
                        label={"Branch Name"}
                        required={true}
                        rules={[
                            () => ({
                                validator(_, value) {
                                    if (!value) {
                                        return Promise.reject();
                                    }
                                    if (!isNaN(value)) {
                                        return Promise.reject("Branch name should be text.");
                                    }
                                    return Promise.resolve();
                                },
                            }),
                        ]}
                    >
                        <Input placeholder={'Enter branch name'}/>
                    </Form.Item>
                    <Form.Item
                        name={"branchCode"}
                        label={"Branch Code"}
                        required={true}
                        rules={[{required: true, message: "Branch Code is required"}]}
                    >
                        <Input placeholder={'Enter branch code'}/>
                    </Form.Item>
                </div>
            </Form>
            <div className={'employee-create__actions'}>
                <Button onClick={handleResetFields}>Reset</Button>
                <Button
                    type={"primary"}
                    htmlType={"submit"}
                    disabled={!valid}
                    onClick={handleFormFinish}
                >
                    Submit
                </Button>
            </div>
        </section>
    )
}


export default BankDetailView;
